<style src="./style.scss">
</style>

<script>
  import { beforeUpdate } from "svelte";
  import Button from "@components/button";
  import Modal from "@components/modal";
  import CardLockedImage from "@assets/images/header_logo.png";
  import CardRefusedImage from "@assets/images/card-refused.gif";
  import CardWithIncorrectInfoImage from "@assets/images/card-with-incorrect-info.gif";
  import CardWithoutLimitImage from "@assets/images/card-without-limit.gif";
  import CreditCard from "@components/creditCard";
  import DebitCardImage from "@assets/images/debit-card.gif";

  export let error;
  export let isOpen = false;
  export let tryAgain = () => null;
  export let onClose = () => null;

  let paymentError = {};

  beforeUpdate(() => {
    if (isOpen && error) {
      switch (error) {
        case "card-without-limit":
          paymentError = {
            title: "Pagamento não autorizado",
            description:
              "Alguns dizem que quem tem limite é município, mas, hoje, seu banco infelizmente colocou um entre nós.",
            button: "Tentar com outro cartão",
            tryAgainMessage: null,
            error,
          };
          break;
        case "card-locked":
          paymentError = {
            title: "Pagamento não autorizado",
            button: "Usar outro cartão",
            description:
              "Ops! Parece que seu cartão está bloqueado. Isso é muito comum com cartões que acabaram de ser emitidos.",
            tryAgainMessage:
              "Escolha uma opção abaixo para concluirmos sua assinatura:",
            tryAgainButton: "Já desbloqueei, usar o mesmo",
            error,
          };
          break;
        case "card-with-incorrect-info":
          paymentError = {
            title: "Pagamento não autorizado",
            description:
              "Ops! Não foi possível processar sua transação. Pode ser que tenha algum dado errado ou que o cartão esteja bloqueado. Let’s try again?",
            button: "Tentar de novo. Agora vai!",
            tryAgainMessage: null,
            error,
          };
          break;
        case "debit-card":
          paymentError = {
            title: "Pagamento não autorizado",
            button: "Usar um cartão de crédito",
            description:
              "Ops! Parece que você usou um cartão de débito. Como a contratação é por meio de uma assinatura, infelizmente só aceitamos cartões de crédito. Desculpe!",
            tryAgainMessage: null,
            error,
          };
          break;
        case "card-refused":
          paymentError = {
            title: "Pagamento não autorizado",
            button: "Tentar novamente",
            description:
              "EITA! Seu banco não autorizou a transação, e também não falou o porquê.",
            tryAgainMessage:
              "Recomendamos tentar com outro cartão ou entrar em contato com o emissor do cartão.",
            error,
          };
          break;
        case "too-many-attempts":
          showMessage(
            "Você excedeu o limite de tentativas, aguarde alguns minutos para tentar novamente.",
            "alert"
          );
          break;
        default:
          paymentError = {
            title: "Pagamento não autorizado",
            button: "Tentar novamente",
            description:
              "EITA! Seu banco não autorizou a transação, e também não falou o porquê.",
            tryAgainMessage:
              "Recomendamos tentar com outro cartão ou entrar em contato com o emissor do cartão.",
            error: "card-refused",
          };
          break;
      }
    }
  });
</script>

<Modal isOpen="{isOpen}" title="{paymentError?.title}" onClose="{onClose}">
  <div class="payment-error-modal">
    {paymentError?.description}

    {#if paymentError?.error === "card-without-limit"}
      <img src="{CardWithoutLimitImage}" alt="" />
    {/if}
    {#if paymentError?.error === "card-locked"}
      <img src="{CardLockedImage}" alt="" />
    {/if}
    {#if paymentError?.error === "card-with-incorrect-info"}
      <img src="{CardWithIncorrectInfoImage}" alt="" />
    {/if}
    {#if paymentError?.error === "debit-card"}
      <img src="{DebitCardImage}" alt="" />
    {/if}
    {#if paymentError?.error === "card-refused"}
      <img src="{CardRefusedImage}" alt="" />
    {/if}
    {#if paymentError?.error === "too-many-attempts"}
      <img src="{CardRefusedImage}" alt="" />
    {/if}

    <div class="payment-error-modal__try-again-message">
      {paymentError?.tryAgainMessage || ""}
    </div>
    {#if paymentError?.tryAgainButton}
      <div>
        <Button
          title="{paymentError?.tryAgainButton}"
          onClick="{tryAgain}"
          type="secondary" />
      </div>
    {/if}

    <div>
      <Button title="{paymentError?.button}" onClick="{tryAgain}" />
    </div>
  </div>
</Modal>
